import axios from 'axios';
import ConfigService from './config.service';
import { IPortCode } from '../contracts/port-code.contract';

const getSearch = async (searchString: string): Promise<IPortCode> => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/PortCode/Match/${searchString}`);
    return res.data;
};

const getSearchCountryLookup = async (searchString: string) => {
    const res = await axios.get(`${ConfigService.appConfig.baseApiUrl}/PortCode/MatchCountryLookup/${searchString}`);
    return res.data;
};

const PortCodeService = {
    getSearch,
    getSearchCountryLookup
};

export default PortCodeService;
